export default function isImpersonatingUser(userData) {
    const origSub = userData?.data?.orig_sub
    const username = userData?.data?.username

    return origSub && username && origSub !== username
}
